/**
 * Anchor matching utilities for ChordPro feedback.
 *
 * These functions extract plain text from ChordPro parsed lines
 * and match comment anchors against that text, enabling feedback
 * to reference lyrics regardless of chord placement.
 */

import type { Line } from "chordsheetjs";
import { ChordLyricsPair, Comment, Literal } from "chordsheetjs";

/**
 * Get the full lyrics text from a parsed ChordPro line (stripping chords).
 *
 * Example: "[G]The night is [D]almost gone" → "The night is almost gone"
 */
export function getLineText(line: Line): string {
  let text = "";
  for (const item of line.items) {
    if (item instanceof ChordLyricsPair) {
      text += item.lyrics || "";
    } else if (item instanceof Comment) {
      text += item.content || "";
    } else if (item instanceof Literal) {
      text += item.string || "";
    }
  }
  return text;
}

/**
 * Check if any of the anchors match text in a line (case-insensitive).
 */
export function lineMatchesAnchors(
  lineText: string,
  anchors: string[],
): boolean {
  const lowerLine = lineText.toLowerCase();
  return anchors.some((anchor) => lowerLine.includes(anchor.toLowerCase()));
}
